









































import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { IProduct } from '@/common/interfaces/products.interface';
import SingleIdealSupplement from '@/components/newsingleproductpage/subcomponents/SingleIdealSupplement.vue';
import { ISplideOptions } from '@/common/interfaces/external.interface';
import { IEventListener, IIcons } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';

interface IIdealSupplementsSectionComponent {
  icons: IIcons;
  limitingActive: boolean;
  mountedDocumentEventListeners: IEventListener[];
  shoppingAllowed: boolean;
  splideOptions: ISplideOptions;
}

export default Vue.extend({
  name: `IdealSupplementsSection`,
  components: { SingleIdealSupplement, Splide, SplideSlide },
  data(): IIdealSupplementsSectionComponent {
    return {
      icons: TIcons,
      limitingActive: false,
      mountedDocumentEventListeners: [],
      shoppingAllowed: false,
      splideOptions: {
        arrows: true,
        pagination: false,
        type: `loop`,
      },
    };
  },
  props: {
    idealSupplements: {
      required: true,
      type: Array as () => IProduct[],
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    selectedCartId: {
      required: true,
      type: Number,
    },
  },
});
